<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">รายงานการสอนรายวิชาศึกษาทั่วไป</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text class="blue-grey">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12  md12 >
            <v-select
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              return-object
              dark
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-text>
      <v-expansion-panel>

        <!-- CONTENT #1 -->
        <v-expansion-panel-content @click.native="reportType = 'A'" :class="reportType === 'A' ? 'blue-grey lighten-5' : '' ">
          <template v-slot:header>
            <div class="font-weight-bold blue-grey--text">ข้อมูลการสอนรายบุคคล <span class="deep-orange--text">{{semester}}</span></div>
          </template>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md5 offset-md1>
                    <span class="blue-grey--text"><strong>เลือกตามประเภทบุคคล</strong></span>
                    <v-radio-group v-model="params.insider" row :disabled="disabledReportType || reportType !== 'A' || disabled">
                      <v-radio label="บุคคลภายใน" value="true"></v-radio>
                      <v-radio label="บุคคลภายนอก" value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 md6>
                    <span class="blue-grey--text"><strong>เลือกตามบุคคล</strong></span>
                    <v-autocomplete
                      :loading="loadingAcademicYear"
                      :items="personItems"
                      label="อาจารย์"
                      v-model="params.person"
                      item-value="id"
                      item-text="fullname"
                      outline
                      hide-details
                      clearable
                      :disabled="disabledReportType || reportType !== 'A'" 
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-slide-x-transition mode="out-in">
                        <v-btn
                          color="info"
                          target="_new" 
                          :href="printoutUrl"
                          v-if="activeBtnA"
                        >
                          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
                        </v-btn>
                      </v-slide-x-transition>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        
        <!-- CONTENT #2 -->
        <v-expansion-panel-content @click.native="reportType = 'B'" :class="reportType === 'B' ? 'blue-grey lighten-5' : '' ">
          <template v-slot:header>
            <div class="font-weight-bold blue-grey--text">ข้อมูลการสอนรายวิชา <span class="deep-orange--text">{{semester}}</span> (รายงานครั้งละ ปี/ภาคการศึกษา)</div>
          </template>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs11 offset-xs1 md11 offset-md1>
                    <v-layout row wrap>
                    <span class="body-2 pr-5 font-weight-bold grey--text">รูปแบบรายงาน</span>
                    <v-radio-group v-model="btype" row :disabled="disabledReportType || reportType !== 'B'">
                      <v-radio color="green" label="ตามวิชา" value="1"></v-radio>
                      <v-radio color="green" label="ตามความรับผิดชอบ" value="2"></v-radio>
                      <v-radio color="green" label="รายงานประธานวิชา" value="3"></v-radio>
                    </v-radio-group>
                    </v-layout>
                  </v-flex>
                  <v-flex xs11 offset-xs1 md11 offset-md1>
                    <v-autocomplete
                      :loading="loadingSubjects"
                      :items="subjectItems"
                      v-model="params.subject"
                      label="วิชา"
                      item-value="id"
                      item-text="label"
                      return-object
                      :disabled="btype > 1 || reportType !== 'B'"
                      clearable                       
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-slide-x-transition mode="out-in">
                        <v-btn
                          color="info"
                          target="_new" 
                          :href="printoutUrl"
                          v-if="activeBtnB"
                        >
                          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
                        </v-btn>
                      </v-slide-x-transition>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        
        <!-- CONTENT #3 -->
        <v-expansion-panel-content @click.native="reportType = 'C'" :class="reportType === 'C' ? 'blue-grey lighten-5' : '' ">
          <template v-slot:header>
            <div class="font-weight-bold blue-grey--text">หนังสือขออนุญาตสอน <span class="deep-orange--text">{{semester}}</span></div>
          </template>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs11 offset-xs1 md11 offset-md1>
                    <v-autocomplete
                      v-model="params.department"
                      :items="departmentItems"
                      color="blue"
                      item-text="label"
                      item-value="id"
                      label="คณะ/ภาควิชา"
                      return-object
                      clearable 
                      :disabled="params.academicYear === null || params.academicYear.id === 0 || reportType !== 'C'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-slide-x-transition mode="out-in">
                        <v-btn
                          color="info"
                          target="_new" 
                          :href="printoutUrl"
                          v-if="activeBtnC"
                        >
                          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
                        </v-btn>
                      </v-slide-x-transition>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text> 

  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      active: false,
      disabled: false,
      loading: false,
      loadingAcademicYear: false,
      loadingSubjects: false,
      academicYearItems: [],
      subjectItems: [],
      departmentItems: [],
      semester: '',
      params: {
        academicYear: null,
        insider: 'true',
        person: null,
        subject: null,
        department: null,
        faculty: null
      },
      reportType: '',
      btype: '1',
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง',
        required2: (value) => value == "NORMAL" || value == "INTER" || value == "ARCH" || "ไม่สามารถเป็นค่าว่าง",
        required3: (value)  => !!value.id || 'ไม่สามารถเป็นค่าว่าง'
      }
    }
  },
  computed: {
    ...mapGetters ({
      token: 'token',
      personItems: 'person/personItems'
    }),
    disabledReportType () {
      return this.params.academicYear === null
    },
    disabledWhenAllYaer () {
      return this.params.academicYear.id === 0
    },
    printoutUrl () {
      if(this.reportType === 'A') return this.urlReportA
      if(this.reportType === 'B') return this.urlReportB
      if(this.reportType === 'C') return this.urlReportC
    },
    urlReportA () {
      if(this.params.person) {
          return `${config.serverURI}/reports/printout/teachingSubjectsByPerson?person=${this.params.person}&academicYear=${this.params.academicYear.id}&access_token=${this.token}`
        } else {
          return `${config.serverURI}/reports/printout/teachingSubjects?academicYear=${this.params.academicYear.id}&insider=${this.params.insider}&access_token=${this.token}`
        }
    },
    urlReportB () {
      if(this.btype === '1') return `${config.serverURI}/reports/printout/teachingSubjectsBySubject?academicYear=${this.params.academicYear.id}&subject=${this.params.subject.id}&access_token=${this.token}`
      if(this.btype === '2') return `${config.serverURI}/reports/printout/teachingSubjectsTeacher?academicYear=${this.params.academicYear.id}&access_token=${this.token}`
      if(this.btype === '3') return `${config.serverURI}/reports/printout/teachingSubjectsHeadsubject?academicYear=${this.params.academicYear.id}&access_token=${this.token}`
    },
    urlReportC () {
      return `${config.serverURI}/reports/printout/teachingSubjectsApproval?academicYear=${this.params.academicYear.id}&department=${this.params.department.id}&faculty=${this.params.faculty.id}&access_token=${this.token}`
    },
    activeBtnA () {
      return this.params.academicYear !== null && this.reportType === 'A' 
    },
    activeBtnB () {
      let activeB = false
      if(this.btype > 1) {
        console.log('btype', this.btype)
        activeB = true
      } else {
        (this.params.subject !== null) ? (activeB = true) : (activeB = false)
      }
      return activeB && this.params.academicYear !== null && this.reportType === 'B' 
    },
    activeBtnC () {
      return this.reportType === 'C' && this.params.department !== null
    }
  },
  mounted () {
    this.fetchAcademicYears ()
    this.fetchDepartments ()
    if(this.personItems.length === 0)  this.fetchPeople ()
  },
  methods: {
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = [{ id: 0, yearSemester: 'ทั้งหมด' }].concat(response.data)
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    },
    fetchPeople () {
      this.$store.dispatch('person/fetchPersonItems')
    },
    fetchActiveCourseItemsByAcademicYear (academicYear) {
      this.loadingSubjects = true
      this.$store.dispatch("activeCourse/loadItemsByAcademicYear", academicYear)
        .then((response) => {
          this.subjectItems = []
          for (const item of response.data) {
            this.subjectItems.push({id: item.subject.id, label: item.subject.label})
          }
          this.subjectItems = [{id: 999, label: 'ทั้งหมด'}].concat(this.subjectItems.sort((a, b) => (a.label > b.label) ? 1 : -1))
          this.loadingSubjects = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingSubjects = false
        })
    },
    fetchDepartments () {
      this.$store.dispatch('department/loadItems')
        .then((response) => {
          // console.log('fetchDepartments:', response.data )
          this.departmentItems = response.data
        }).catch((error) => {
          swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    'params': {
      handler (val) {
        if(val.academicYear) this.semester = `ปี/ภาคการศึกษา ${val.academicYear.yearSemester}`
        if(val.academicYear && val.academicYear.id>0) this.fetchActiveCourseItemsByAcademicYear(val.academicYear.id)
        if(!val.academicYear || val.academicYear.id===0) {
          this.subjectItems = []
          this.params.department = null
        }
        if(val.person) {
          this.disabled = true
        } else {
          this.disabled = false
        }
        if(val.department) {
          this.params.faculty = val.department.faculty
        } else {
          this.params.department = null
        }
      },
      deep: true
    },
    btype (val) {
      if(val>1) this.params.subject = null
    },
    reportType (val) {
      if( val === 'A') {
        console.log('reportType A')
        this.academicYearItems = [{ id: 0, yearSemester: 'ทั้งหมด' }].concat(this.academicYearItems)      
      } else {
        this.params.academicYear = null
        this.semester = ''
        this.academicYearItems = this.academicYearItems.filter(function(el) { return el.id != 0; })
      }
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/teachingSubjects/index.vue